

















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import mockTeam from "@/mock/team";
@Component
export default class ResearchView extends Vue {
  teachers = mockTeam.teachers;
  docters = mockTeam.docters;
  masters = mockTeam.masters;
  undergraduates = mockTeam.undergraduates;
  graduates = mockTeam.graduates;
  allPeople = [
    ...this.docters,
    ...this.masters,
    ...this.undergraduates,
    ...this.graduates,
  ];
  imgList = this.allPeople.map((a) => a.image);
  chooseImage(url: any) {


    var tempList = [];
    var tempList2 = [];
    var flag = false;
    for (let i = 0; i < this.imgList.length; i++) {
      if (this.imgList[i] == url) {
        flag = true;
      }
      if (!flag && this.imgList[i] != url) {
        tempList.push(this.imgList[i]);
      } else {
        tempList2.push(this.imgList[i]);
      }
    }
    this.imgList = [...tempList2, ...tempList];
  }
}
